import { createRoot } from "react-dom/client";
import { TokenPage } from "./token_list";

window.onload = async () => {
	const container = document.getElementById("token-list");
	const root = createRoot(container);
	root.render(<TokenPage />);
};
